﻿import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min';

import promise from 'es6-promise';
promise.polyfill();

import Vue from 'vue';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引入全局样式（必须在 element-ui 之后）
import './assets/css/global.css';

import ECharts from 'vue-echarts'; // 引入组件
import 'echarts'; // 引入echarts核心

import App from './App.vue';

// 引入router.js
import router from './router.js'

import { TYBM_UIValidate } from './ui-validate.js';

// Element UI配置
Vue.use(ElementUI, {
    size: 'medium'
});


Vue.component('v-chart', ECharts);

Vue.config.productionTip = false;

TYBM_UIValidate.Init();

// 全局事件总线
Vue.prototype.$bus = new Vue();

new Vue({
    router,
    render: h => h(App),
    components: { App }
}).$mount('#app');
